import React, { useState } from "react";
import {
    Box,
    Select,
    MenuItem,
    FormControl,
    Typography,
} from "@mui/material";
import {
    GridPagination,
    useGridApiContext,
    useGridSelector,
    gridPageCountSelector,
    gridPageSelector,
    gridPageSizeSelector,
    gridRowCountSelector
} from "@mui/x-data-grid-premium";
import { useTranslation } from "react-i18next";

export const CustomPagination = () => {
    const apiRef = useGridApiContext();
    const { t } = useTranslation();

    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
    const rowCount = useGridSelector(apiRef, gridRowCountSelector);

    const [pageSelectOpen, setPageSelectOpen] = useState(false);

    // For server-side pagination, calculate pageCount from rowCount and pageSize
    // For client-side pagination, use the pageCount from selector
    const effectivePageCount = rowCount && pageSize
        ? Math.ceil(rowCount / pageSize)
        : pageCount;

    const handlePageChange = (newPage: number) => {
        apiRef.current.setPage(newPage);
    };

    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "100%",
            px: 2,
            py: 1,
            gap: 2
        }}
        >
            <GridPagination />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body2" color="text.secondary">
                    {t("common.GoToPage")}:
                </Typography>
                <FormControl size="small" sx={{ minWidth: 80 }}>
                    <Select
                        value={page + 1} // Convert 0-based to 1-based for display
                        onChange={(e) => handlePageChange(Number(e.target.value) - 1)} // Convert back to 0-based
                        open={pageSelectOpen}
                        onOpen={() => setPageSelectOpen(true)}
                        onClose={() => setPageSelectOpen(false)}
                        sx={{
                            "& .MuiSelect-select": {
                                py: 0.5,
                                fontSize: "0.875rem"
                            }
                        }}
                    >
                        {Array.from({ length: effectivePageCount }, (_, i) => (
                            <MenuItem key={i + 1} value={i + 1}> {/* Use 1-based values */}
                                {i + 1}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Typography variant="body2" color="text.secondary">
                    / {effectivePageCount}
                </Typography>
            </Box>
        </Box>
    );
};